module.exports = __webpack_public_path__ + "static/bg-hero-157584f11c0ada6c0395832ce33f4ba1.jpg";